import { render } from "./404.vue?vue&type=template&id=47c87a87&scoped=true"
const script = {}

import "./404.vue?vue&type=style&index=0&id=47c87a87&scoped=true&lang=scss"

import exportComponent from "/home/nathan/public_html/accident-plan/accident-plan-api-whitelabel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47c87a87"]])

export default __exports__